export default __webpack_public_path__ + "static/media/movr.481dd04d.svg";